import request from '@/utils/request'

export function getUserRemain(data) {
  return request({
    url: 'api/v1/user_remain/list',
    method: 'post',
    data: data
  })
}

export function getLoginRemain(data) {
  return request({
    url: 'api/v1/user_remain/loginRemain',
    method: 'post',
    data: data
  })
}

export function getPayRemain(data) {
  return request({
    url: 'api/v1/user_remain/payRemain',
    method: 'post',
    data: data
  })
}

export function getRegPayRemain(data) {
  return request({
    url: 'api/v1/user_remain/regPayRemain',
    method: 'post',
    data: data
  })
}

export function getUserLoss(data) {
  return request({
    url: 'api/v1/user_remain/loss',
    method: 'post',
    data: data
  })
}

export function getLevelLoss(data) {
  return request({
    url: 'api/v1/user_remain/levelLoss',
    method: 'post',
    data: data
  })
}

export function getLevelLoss2(data) {
  return request({
    url: 'api/v1/user_remain/levelLoss2',
    method: 'post',
    data: data
  })
}

export function getUserSpinStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserSpins',
    method: 'post',
    data: data
  })
}

export function getUserGroupStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserGroup',
    method: 'post',
    data: data
  })
}

export function getUserGroupDataStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserGroupStat',
    method: 'post',
    data: data
  })
}

export function getUserGroupRewardData(data) {
  return request({
    url: 'api/v1/user_remain/getUserGroupReward',
    method: 'post',
    data: data
  })
}

export function getUserBeastCoinStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserBeastCoin',
    method: 'post',
    data: data
  })
}

export function getUserDiamondStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserDiamond',
    method: 'post',
    data: data
  })
}

export function getUserVersionStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserVersion',
    method: 'post',
    data: data
  })
}

export function getUserCoinStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserCoins',
    method: 'post',
    data: data
  })
}
export function getUserStat(data) {
  return request({
    url: 'api/v1/user/getUserTotalStat',
    method: 'post',
    data: data
  })
}
export function getUserConsumeStat(data) {
  return request({
    url: 'api/v1/user/getUserConsumeStat',
    method: 'post',
    data: data
  })
}
export function importAd(data) {
  return request({
    url: 'api/v1/user_remain/importAd',
    method: 'post',
    data: data
  })
}

export function getAd(data) {
  return request({
    url: 'api/v1/user_remain/getAd',
    method: 'post',
    data: data
  })
}

export function getRoi2(data) {
  return request({
    url: 'api/v1/user_remain/getRoi2',
    method: 'post',
    data: data
  })
}

export function handleRoi(data) {
  return request({
    url: 'api/v1/user_remain/handleRoi2',
    method: 'post',
    data: data
  })
}

export function getUserLevelStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserLevel2',
    method: 'post',
    data: data
  })
}

export function getUserLevelStat2(data) {
  return request({
    url: 'api/v1/user_remain/getUserLevel',
    method: 'post',
    data: data
  })
}

export function getUserOnline(data) {
  return request({
    url: 'api/v1/user_remain/online',
    method: 'post',
    data: data
  })
}

export function getUserRegAnalyze(data) {
  return request({
    url: 'api/v1/user_remain/getUserRegAnalyze',
    method: 'post',
    data: data
  })
}

export function getIndexPayData(data) {
  return request({
    url: 'api/v1/user_remain/getIndexPayData',
    method: 'post',
    data: data
  })
}

export function getSubVipStat(data) {
  return request({
    url: 'api/v1/user_remain/getSubVip',
    method: 'post',
    data: data
  })
}

export function getLoginStat(data) {
  return request({
    url: 'api/v1/user_remain/loginStat',
    method: 'post',
    data: data
  })
}

export function getLtvData(data) {
  return request({
    url: 'api/v1/user_remain/getLtvData',
    method: 'post',
    data: data
  })
}

export function getSpinsConsume(data) {
  return request({
    url: 'api/v1/user_remain/getSpinsConsume',
    method: 'post',
    data: data
  })
}

export function getSpinsConsumeV2(data) {
  return request({
    url: 'api/v1/user_remain/getSpinsConsumeV2',
    method: 'post',
    data: data
  })
}

export function getGrantPercentStat(data) {
  return request({
    url: 'api/v1/user_remain/getGrantPercentStat',
    method: 'post',
    data: data
  })
}

export function getRidData(data) {
  return request({
    url: 'api/v1/user_remain/getRidData',
    method: 'post',
    data: data
  })
}

export function getUserSpinsRate(data) {
  return request({
    url: 'api/v1/user_remain/getUserSpinsRateData',
    method: 'post',
    data: data
  })
}

export function getGrantStat(data) {
  return request({
    url: 'api/v1/user_remain/getGrantStatData',
    method: 'post',
    data: data
  })
}

export function getGrantRankStat(data) {
  return request({
    url: 'api/v1/user_remain/getGrantRankStatData',
    method: 'post',
    data: data
  })
}

export function getRankData(data) {
  return request({
    url: 'api/v1/user_remain/getRankData',
    method: 'post',
    data: data,
    timeout: 50000
  })
}

export function getAttackStealRankData(data) {
  return request({
    url: 'api/v1/user_remain/getAttackStealRankData',
    method: 'post',
    data: data,
    timeout: 50000
  })
}

export function getGoodsAnalyzeData(data) {
  return request({
    url: 'api/v1/user_remain/getGoodsAnalyze',
    method: 'post',
    data: data,
    timeout: 50000
  })
}

export function getActStat(data) {
  return request({
    url: 'api/v1/user_remain/actStat',
    method: 'post',
    data: data
  })
}

export function getUserDataAvgStat(data) {
  return request({
    url: 'api/v1/user_remain/userAvgStat',
    method: 'post',
    data: data
  })
}

export function getNotBuildStat(data) {
  return request({
    url: 'api/v1/user_remain/getNotBuildStat',
    method: 'post',
    data: data
  })
}

export function getUserConsumeDataStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserConsumeDataStat',
    method: 'post',
    data: data
  })
}

export function getUserSkinDataStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserSkinDataStat',
    method: 'post',
    data: data
  })
}

export function getChessBoardRateStat(data) {
  return request({
    url: 'api/v1/user_remain/getChessBoardRateStat',
    method: 'post',
    data: data
  })
}

export function getLoginEventRateStat(data) {
  return request({
    url: 'api/v1/user_remain/getLoginEventStat',
    method: 'post',
    data: data
  })
}

export function getReportRateStat(data) {
  return request({
    url: 'api/v1/user_remain/getReportRateStat',
    method: 'post',
    data: data
  })
}

export function getPayPopUpRateStat(data) {
  return request({
    url: 'api/v1/user_remain/getPayPopUpStat',
    method: 'post',
    data: data
  })
}
export function getPayStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserPayAnalyze',
    method: 'post',
    data: data
  })
}

export function getLoginStat1(data) {
  return request({
    url: 'api/v1/user_remain/getUserLoginAnalyze',
    method: 'post',
    data: data
  })
}

export function getLoginCountStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserLoginAnalyze',
    method: 'post',
    data: data
  })
}
export function exportStatData(data) {
  return request({
    url: 'api/v1/user_remain/export',
    method: 'post',
    data: data
  })
}

export function exportPayStatData(data) {
  return request({
    url: 'api/v1/user_remain/payStat',
    method: 'post',
    data: data
  })
}

export function getGiftData(data) {
  return request({
    url: 'api/v1/user_remain/payStat',
    method: 'post',
    data: data
  })
}

export function getUserAnalyze(data) {
  return request({
    url: 'api/v1/user_remain/getAnalyze',
    method: 'post',
    data: data
  })
}

export function getNewUserStat(data) {
  return request({
    url: 'api/v1/user_remain/getNewUserStat',
    method: 'post',
    data: data
  })
}

export function getNewUserLevelStat(data) {
  return request({
    url: 'api/v1/user_remain/getNewUserLevelStat',
    method: 'post',
    data: data
  })
}

export function getNewUserSpinStat(data) {
  return request({
    url: 'api/v1/user_remain/getNewUserSpinStat',
    method: 'post',
    data: data
  })
}

export function getAdViewStat(data) {
  return request({
    url: 'api/v1/user_remain/getAdViewStat',
    method: 'post',
    data: data
  })
}

export function getAdReportStat(data) {
  return request({
    url: 'api/v1/user_remain/getAdReportStat',
    method: 'post',
    data: data
  })
}

export function getAbnormalUserStat(data) {
  return request({
    url: 'api/v1/user_remain/getAbnormalUserStat',
    method: 'post',
    data: data
  })
}

export function getPayLevelStat(data) {
  return request({
    url: 'api/v1/user_remain/getPayLevelStat',
    method: 'post',
    data: data
  })
}

export function getDauMauStat(data) {
  return request({
    url: 'api/v1/user_remain/getUserDauMau',
    method: 'post',
    data: data
  })
}

export function getFinishtutorial(data) {
  return request({
    url: 'api/v1/user_remain/getFinishtutorial',
    method: 'post',
    data: data
  })
}

export function getSpinsConsumeStatDay(data) {
  return request({
    url: 'api/v1/user_remain/getSpinsConsumeStatDay',
    method: 'post',
    data: data
  })
}

export function getUserPayPermeability(data) {
  return request({
    url: 'api/v1/user_remain/getUserPayPermeability',
    method: 'post',
    data: data
  })
}

export function getUserSignType(data) {
  return request({
    url: 'api/v1/user_remain/getUserSignTypeUser',
    method: 'post',
    data: data
  })
}

export function getCooperativeBuildStat(data) {
  return request({
    url: 'api/v1/user_remain/getCooperativeBuildStat',
    method: 'post',
    data: data
  })
}

export function getCooperativeTreasureStat(data) {
  return request({
    url: 'api/v1/user_remain/getCooperativeTreasureStat',
    method: 'post',
    data: data
  })
}

export function getTreasureHunting(data) {
  return request({
    url: 'api/v1/user_remain/getTreasureHuntingStat',
    method: 'post',
    data: data
  })
}

export function getCarnivalStat(data) {
  return request({
    url: 'api/v1/user_remain/getCarnivalStat',
    method: 'post',
    data: data
  })
}

export function getRealTimeCount(data) {
  return request({
    url: 'api/v1/user_remain/realTimeCount',
    method: 'post',
    data: data
  })
}

export function getPayProcessStat(data) {
  return request({
    url: 'api/v1/user_remain/getPayProcessStat',
    method: 'post',
    data: data
  })
}
